export default __webpack_public_path__ + "static/gender-neutral-anterior-84ec13f1502da2266e4652e4304a45a2.webp";